import { useQuery } from "@tanstack/vue-query";
import APIClient from "@/APIClient";
import { QueryKey } from "./query-keys";
import { type Ref } from "vue";
import type { PaginationParams } from "@/types";
import type { FetchDisorderTemplatesFilters } from "@/types/catalogues.types";

export const useGetCatalogues = () => {
  return useQuery({
    queryKey: [QueryKey.CATALOGUES],
    queryFn: async () => {
      return await APIClient.fetchEnabledCatalogues();
    },
    refetchOnWindowFocus: false,
  });
};

export const useGetCataloguePartsTree = (id: Ref<number>) => {
  return useQuery({
    queryKey: [QueryKey.CATALOGUES, "tree", id],
    queryFn: async () => {
      return await APIClient.fetchCataloguePartsTree(id.value);
    },
  });
};

export const useGetDisorderTemplates = (
  pagination: Ref<PaginationParams>,
  filters: Ref<FetchDisorderTemplatesFilters>,
) => {
  const queryKey = [QueryKey.DISORDER_TEMPLATES, pagination, filters];

  return useQuery({
    queryKey,
    queryFn: async () => {
      const res = await APIClient.fetchDisorderTemplates({
        ...pagination.value,
        ...filters.value,
      });

      return res;
    },

    refetchOnWindowFocus: false,
  });
};
